'use client';

import { Typography } from '@musinsa/mds';

interface AccountInfoViewProps {
  bankName?: string;
  accountNumber?: string;
  accountHolder?: string;
}

export const AccountInfoView = ({
  bankName,
  accountNumber,
  accountHolder,
}: AccountInfoViewProps) => (
  <div className="flex flex-col gap-2 pb-2">
    <Typography variant="body13pxReg">{bankName || '-'}</Typography>

    {accountNumber && <Typography variant="body13pxReg">{accountNumber}</Typography>}

    {accountHolder && <Typography variant="body13pxReg">{accountHolder}</Typography>}
  </div>
);
